import type { WebViewDto } from '@/api/webs'
import { QuizPanel } from '../panels/QuizPanel'

interface Props {
  web: WebViewDto
  onPatchWeb: (patcher: (prev: WebViewDto) => WebViewDto) => void
}

// Hosts the quiz on a Download web. WebDetail only renders this tab for Download webs.
export function WebQuizTab({ web, onPatchWeb }: Props) {
  return <QuizPanel web={web} onPatchWeb={onPatchWeb} isSignedOff={web.ApprovalStatus === 'Signed Off'} />
}
